// extracted by mini-css-extract-plugin
export default {"loader-position":"_1hh4zfd","loaderPosition":"_1hh4zfd","loader-position-grey":"_1dzfh03","loaderPositionGrey":"_1dzfh03"};